import { gql } from "@apollo/client";

export const ADD_SAME_DAY_ORDER = gql`
mutation AddOrderForSameDay($input: OrderSameDayInput) {
  addOrderForSameDay(input: $input) {
    id
    data
    status
    paymentDetails
    order_amount
    order_id
    sameDay_order_percentage
    request_id
    paymentSessionId
    cfToken
    cfOrderId
    paymentStatus
    tracking_url
    trackStatus
  }
}
`

export const GET_ORDER_SAME_DAY = gql`
query GetOrdersforSameDay($page: Int, $limit: Int, $sort: orderSort, $filter: String, $from: String, $to: String, $orderStatus: String, $customerId: String, $tag: String,$paymentStatus:String) {
  getOrdersforSameDay(page: $page, limit: $limit, sort: $sort, filter: $filter, from: $from, to: $to, orderStatus: $orderStatus, customerId: $customerId, tag: $tag,paymentStatus: $paymentStatus) {
    count
    data {
      id
      data
      status
      paymentDetails
      order_amount
      order_id
      sameDay_order_percentage
      request_id
      paymentSessionId
      cfToken
      cfOrderId
      paymentStatus
      driverInfo
      tracking_url
      estimated_pickup_time
      trackStatus
      createdAt
    }
  }
}
`
export const GET_SINGLE_ORDER = gql`
query GetOrderforSameDay($getOrderforSameDayId: String) {
  getOrderforSameDay(id: $getOrderforSameDayId) {
    id
    data
    status
    paymentDetails
    order_amount
    order_id
    sameDay_order_percentage
    request_id
    paymentSessionId
    cfToken
    cfOrderId
    paymentStatus
    driverInfo
    tracking_url
    estimated_pickup_time
    trackStatus
    createdAt
  }
}
`

export const CANCEL_COURIER = gql`
mutation CancelCourierSameDay($orderId: String!) {
  cancelCourierSameDay(order_id: $orderId) {
    status
    trackStatus
  }
}
`

export const UPDATE_ORDER = gql`
mutation UpdateOrderForSameDay($input: updateOrderSameDayInput) {
  updateOrderForSameDay(input: $input) {
    id
    data
    status
    paymentDetails
    order_amount
    order_id
    sameDay_order_percentage
    request_id
    paymentSessionId
    cfToken
    cfOrderId
    paymentStatus
    tracking_url
    estimated_pickup_time
    trackStatus
    createdAt
  }
}
`